import { Injectable, UseFilters } from '@nestjs/common';
import { Repository } from 'typeorm';
import { PickUp } from './pickup.entity';
import { PickUpDTO } from './dto/pickup.dto';
import { InjectRepository } from '@nestjs/typeorm';
import { PickUpAdapter } from './dto/pickup.adapter';
import { PickUpResponseModel, AllPickUpResponseModel } from '@gtpl/shared-models/hrms';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { PickUpRequest } from './dto/pickup.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class PickUpService {

    constructor(
      private logService:LogsService,

        @InjectRepository(PickUp)
        private pickUpRepository: Repository<PickUp>,
        private pickUpAdapter: PickUpAdapter,
    ){}

    async getPickUpWithoutRelations(pickUp: string): Promise<PickUp>{
        const pickUpResponse = await  this.pickUpRepository.findOne({
            where: {pickUp: pickUp},
        });
        if(pickUpResponse){
            return pickUpResponse;
        }else {
            return null;
        }
    }

    async createPickUp(pickUpDTO: PickUpDTO, isUpdate: boolean): Promise<PickUpResponseModel>{
        try{
            if(!isUpdate){
                const pickUpEntity = await this.getPickUpWithoutRelations(pickUpDTO.pickUp);
                if(pickUpEntity){
                    throw new ErrorResponse(11104, 'PickUp already exists');
                }
            }else {
                const pickUpEntity = await this.getPickUpWithoutRelations(pickUpDTO.pickUp);
                if(pickUpEntity){
                    if(pickUpEntity.pickUpId != pickUpDTO.pickUpId){
                        throw new ErrorResponse(11104, 'PickUp already exists')
                    }
                }
            }
            const convertedEntity: PickUp = this.pickUpAdapter.convertDtoToEntity(pickUpDTO, isUpdate);
            const savedEntity: PickUp = await this.pickUpRepository.save(convertedEntity);
            const savedDto: PickUpDTO = this.pickUpAdapter.convertEntityToDto(convertedEntity);
            if(savedDto){
                const response = new PickUpResponseModel(true, 1, isUpdate? 'PickUp Updated Successfully' : 'PickUp Created Successfully');
                const name=isUpdate?'updated':'created'
            
                const newLogDto = new LogsDto(1,name, 'PickUp', savedDto.pickUpId, true, '',savedDto.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            }else{
                throw new ErrorResponse(11106, 'PickUp saved but issue while transforming it into DTO');
            }
        }catch(error){
            throw error;
        }
    }

    async getAllPickUp() : Promise<AllPickUpResponseModel>{
        try{
            const pickUpDtos: PickUpDTO[] = [];
            const pickUpEntities: PickUp[] = await this.pickUpRepository.find({order: {pickUp: 'ASC'}});
            if(pickUpEntities){
                pickUpEntities.forEach(Entity => {
                    const convertedDto: PickUp = this.pickUpAdapter.convertEntityToDto(Entity);
                    pickUpDtos.push(convertedDto);
                });
                const response = new AllPickUpResponseModel(true, 1, 'PickUp Retrieved Successfully', pickUpDtos);
                const newLogDto = new LogsDto(1,'view', 'PickUp', 0, true, '','')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        }catch(err){
            throw err;
        }
    }

    async getAllActivePickUp() : Promise<AllPickUpResponseModel>{
        try{
            const pickUpDtos: PickUpDTO[] = [];
            const pickUpEntities: PickUp[] = await this.pickUpRepository.find({order: {pickUp: 'ASC'}, where: {isActive: true},});
            if(pickUpEntities){
                pickUpEntities.forEach(Entity => {
                    const convertedEntity: PickUp = this.pickUpAdapter.convertEntityToDto(Entity);
                    pickUpDtos.push(convertedEntity);
                });
                const response = new AllPickUpResponseModel(true, 11108, 'Active Loan Categories Retrieved Successfully', pickUpDtos);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        }catch(err){
            throw err;
        }
    }

    async getPickUpById(pickUpId: number): Promise<PickUp>{
        const response = await this.pickUpRepository.findOne({
            where: {pickUpId: pickUpId},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async activateOrDeactivatePickUp(pickUpReq: PickUpRequest): Promise<PickUpResponseModel>{
        try{
            const pickUpExists = await this.getPickUpById(pickUpReq.pickUpId);
            if(pickUpExists){
                if(pickUpReq.versionFlag != pickUpExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone updated the current pickUp information. Refresh and try again');
                }else{
                    const pickupStatus = await this.pickUpRepository.update(
                        {pickUpId: pickUpReq.pickUpId},
                        {isActive: pickUpReq.isActive, updatedUser: pickUpReq.updatedUser}
                    );
                    if(pickUpExists.isActive){
                        if(pickupStatus.affected){
                            const pickUpResponse: PickUpResponseModel = new PickUpResponseModel(true, 10115, 'pickup is de-activated successfully');
                            return pickUpResponse;
                        }else{
                            throw new ErrorResponse(10111, ' pickup is already de-activated');
                        }
                    }else{
                        if(pickupStatus.affected){
                            const pickUpResponse: PickUpResponseModel = new PickUpResponseModel(true, 10114, 'pickup is activated successfully');
                            return pickUpResponse;
                        }else{
                            throw new ErrorResponse(10112, 'pickup is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(err){
            throw err;
        }
    }
}